import { createSlice } from "@reduxjs/toolkit";

const initialStudentAbsenteeismReportState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  authorities: null,
  students: []
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const studentAbsenteeismReportSlice = createSlice({
  name: "studentAbsenteeismReport",
  initialState: initialStudentAbsenteeismReportState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getStudentAbsenteeismReport
    studentAbsenteeismReportFetched: (state, action) => {
      const { isSuccess, type, totalCount, entities, authorities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.entities = entities;
      state.totalCount = totalCount;
      state.authorities = authorities;
    },
    // getSections
    sectionsFetched: (state, action) => {
      const { isSuccess, type, entities } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.sections = entities;
    },
    // getStudents
    studentsFetched: (state, action) => {
      const { isSuccess, type, entities } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.students = entities;
    },
    // completeAction
    actionCompleted: (state) => {
      state.actionsLoading = false;
    },
    // cleanStudentsState
    studentsStateCleaned: (state) => {
      state.students = [];
    },
    // cleanStudentAbsenteeismReportState
    studentAbsenteeismReportStateCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.entities = undefined;
      state.totalCount = 0;
    }
  }
});